<template>
    <div id="app" :class="{'simple-view': isSimpleView}">
        <HomepageVideo v-if="showHomePageVideo" />
        <Nav />
        <router-view :key="$route.fullPath" />
        <div class="top-gray-box margin-top bottom-gray-box" v-if="showSocialLinks">
            <SocialLinks />
        </div>
        <div class="copyright-container">
            <span class="copyright">2023 &copy; All Rights Reserved. <span v-if="settings.siteName == 'mommydeals' || settings.siteName == 'petpetdeals' || settings.siteName == 'chaideals'">{{settings.siteNameCaps}} is a subsidiary of Zigitech Solutions Inc</span></span>
            <span><a href="/privacy-policy">Privacy Policy</a></span>
            <span style="padding: 10px; font-size: 10pt;">Disclosure: {{settings.siteNameCaps}} is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for us to earn advertising fees by advertising and linking to Amazon.com. As An Amazon Associate we earn from qualifying purchases. Product prices and availability are accurate as of the date/time indicated and are subject to change without notice including promo codes.</span>
        </div>
        <newsletter-modal />
    </div>
</template>


<script>

    import Nav from '@/components/Nav.vue'
    import SocialLinks from '@/components/SocialLinks.vue'
    import HomepageVideo from '@/components/HomePageVideo.vue'
    import settings from '@/settings'
    import EventBus from '@/helpers/event-bus'
    import clicky from '@/helpers/clicky'

    export default {
        name: 'home',
        data() {
            return {
                isSimpleView: false,
                showHomePageVideo: false,
                showSocialLinks: true
            }
        },
        created() {
            if (this.$route.query.direct)
                this.isSimpleView = true;
            else
                this.isSimpleView = false;


            if (this.$route.name == 'dealshare' || this.$route.name == 'analysis' || this.$route.name == 'analytics') {
                this.showSocialLinks = false;
            }

            EventBus.$on('playHomepageVideo', () => {
                clicky.log('Open Homepage Video', 'click');
                this.showHomePageVideo = true;
            });
            EventBus.$on('stopHomepageVideo', () => {
                this.showHomePageVideo = false;
            });


        },
        components: {
            Nav,
            SocialLinks,
            HomepageVideo
        },
        computed: {
            settings: function () { return settings; },
        }
    }
</script>